import React from "react";

export default function Eyebrow({ children, className = "", muted = false, ...rest }) {
  return (
    <span className={`${muted ? "eyebrow-muted" : "eyebrow"} ${className}`} {...rest}>
      <span className="inline-block w-8 h-px align-middle bg-current mr-3 opacity-60" />
      {children}
    </span>
  );
}
